// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__wb2GK","about":"About_about__1eeQa","guy":"About_guy__jExPa","markup":"About_markup__luVOo"};